import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useAIAgentData } from "../../hooks/useAIAgentData";

// Shared animation variants
const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.12 },
  }),
} as const;

export default function CustomizationSection() {
  const { data } = useAIAgentData();
  const { badgeText, title, description, items, footerText } = data.customizationSection;

  return (
    <section className="relative px-5 sm:px-10 md:px-16 sm:py-16 py-8">
      <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} className="space-y-8">
          <p className="text-[#A6A0F6] text-sm font-medium tracking-widest uppercase">{badgeText}</p>
          <h2 className="text-4xl md:text-6xl font-bold text-white leading-tight">
            {title}
          </h2>
          <p className="text-2xl text-[#d9d9d9] leading-relaxed">
            {description}
          </p>
        </motion.div>

        <div className="flex flex-wrap gap-3">
          {items.map((item, i) => (
            <motion.div
              key={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              custom={i}
              className="flex items-center gap-2 px-5 py-3 rounded-xl border border-[#1179F9]/30 bg-[#1179F9]/10 text-white text-xl hover:border-[#1179F9]/60 hover:bg-[#1179F9]/20 transition-all"
            >
              <CheckCircle2 size={16} className="text-[#1179F9]" />
              {item}
            </motion.div>
          ))}
          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={items.length}
            className="w-full text-[#d9d9d9] text-xl leading-relaxed pt-2"
          >
            {footerText}
          </motion.p>
        </div>
      </div>
    </section>
  );
}
